import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

// Bus event for the HLRE partner lead reference. Ids + actor only: no conditions, no prices.
export const PartnerLeadReferenceCreatedPayloadSchema = z.object({
  workspaceId: z.uuid(),
  leadId: z.uuid(),
  referenceId: z.uuid(),
  origin: z.enum(['PUSH', 'INITIAL_IMPORT']),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});
export type PartnerLeadReferenceCreatedPayload = z.infer<typeof PartnerLeadReferenceCreatedPayloadSchema>;
